export { AccountActivationComponent } from './account-activation.component'
export { ActivateUserComponent } from './activate-user/activate-user.component'
export { CompleteProfileComponent } from './complete-profile/complete-profile.component'
export { CompleteProfileSelfRegistrationComponent } from './complete-profile-self-registration/complete-profile-self-registration.component'